import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
	Box,
	Button,
	// Box,
	Container,
	Link,
	// Link,
	Stack,
	Typography,
} from '@mui/material';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import ScrollToTop from '../../../components/layout/ScrollToTop';
import { PAGES_URLS } from '../../../lib/constants/routes';

const Impressum: FC<{}> = () => {
	const navigate = useNavigate();
	return (
		<>
			<ScrollToTop />
			<Container>
				<Button
					variant='outlined'
					startIcon={<ArrowBackIcon />}
					sx={{ margin: '0 auto 3rem auto', boxShadow: 'none' }}
					onClick={() => navigate(PAGES_URLS.Startseite)}
				>
					Zurück Zur Startseite
				</Button>
				<Stack spacing={2}>
					<Typography variant='h2' component='h1' sx={{ fontWeight: 600, pb: '.7rem' }} paragraph>
						Impressum
					</Typography>

					<Typography variant='body1' paragraph>
						Angaben gemäß § 5 DDG
						<br />
					</Typography>
					<Typography variant='body1' paragraph>
						Akademie der Künste KöR
						<br />
						Pariser Platz 4
						<br />
						10117 Berlin
					</Typography>
					<Typography variant='body1' paragraph>
						<strong>Vertreten durch:</strong>
						<br />
						Manos Tsangaris
						<br />
						Präsident
					</Typography>
					<Typography variant='body1' paragraph>
						<strong>Kontakt:</strong>
						<br />
						Telefon: +49 (0)30 200 57-1542
						<br />
						E-Mail: <Link href='mailto:literatur@adk.de'>literatur@adk.de</Link>
					</Typography>

					<Typography variant='body1' paragraph>
						<strong>Umsatzsteuer-ID:</strong>
						<br />
						Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz: DE220436340.
					</Typography>

					<Typography variant='body1' sx={{ lineHeight: 2 }} paragraph>
						<strong>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:</strong>
						<br />
						Sektion Literatur
						<br />
						<em>Ansprechpartner für das Stipendienprogramm</em>
						<br />
						Dr. Nathalie Mälzer und Kerstin Gnielka
						<br />
						<em>IT-Beauftragter der Akademie der Künste</em>
						<br />
						Torsten Roloff
						<br />
						<em>Gestaltung und technische Umsetzung</em>
						<br />
						B&amp;IT Services GmbH
					</Typography>

					<Box sx={{ mt: '2rem' }}>
						<Typography variant='body1' paragraph sx={{ mt: '1rem' }}>
							<strong>Haftungsausschluss:</strong>
						</Typography>
						<Typography variant='body1' paragraph>
							<strong>Haftung für Inhalte</strong>
						</Typography>

						<Typography variant='body1' paragraph>
							Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können
							wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 DDG für eigene Inhalte auf diesen Seiten nach den
							allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
							gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
							Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine
							diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
							entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
						</Typography>

						<Typography variant='body1' paragraph>
							<strong>Haftung für Links</strong>
						</Typography>

						<Typography variant='body1' paragraph>
							Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
							fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
							Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige
							Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
							konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links
							umgehend entfernen.
						</Typography>
						<Typography variant='body1' paragraph>
							<strong>Urheberrecht</strong>
						</Typography>

						<Typography variant='body1' paragraph>
							Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die
							Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
							schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht
							kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
							Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung
							aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte
							umgehend entfernen.
						</Typography>
						<Typography variant='body1' paragraph>
							Impressum von <Link rel='noopener noreferrer'>Impressum-Generator.de</Link>. Powered by Franziska Hasselbach, Bonn.
						</Typography>
					</Box>
				</Stack>
			</Container>
		</>
	);
};
export default Impressum;
